import { fromJS } from 'immutable';

import defaultFlowConfig from './flows/defaultFlowConfig';
import stepConfigs from './flows/stepConfigs';



export const FLOW_STORE_NAME = 'flow';
export const FLOW_PROGRESS_STORE_NAME = 'flowProgress';


export const SET_FLOW_CONFIG = '@@storefront/SET_FLOW_CONFIG';
export const SET_STEP_CONFIGS = '@@storefront/SET_STEP_CONFIGS';
export const SET_PREFERRED_CURRENCY = '@@storefront/SET_PREFERRED_CURRENCY';
export const SET_PREFERRED_PROGRAM = '@@storefront/SET_PREFERRED_PROGRAM';
export const FLOW_PARAMS_UPDATED = '@@storefront/FLOW_PARAMS_UPDATED';
export const RESTART_BUY_FLOW = '@@storefront/RESTART_BUY_FLOW';
export const ORDER_COMPLETE = '@@storefront/ORDER_COMPLETE';
export const SHOW_APP_ERROR = '@@storefront/SHOW_APP_ERROR';
export const STEP_CHANGE = '@@storefront/STEP_CHANGE';

export const initialState = fromJS({
    flowConfig: defaultFlowConfig,
    stepConfigs
});


export default function flowReducer(state = initialState, action) {
    switch (action.type) {
        case SET_FLOW_CONFIG:
            return state.set('flowConfig', action.flowConfig);
        case SET_STEP_CONFIGS:
            return state.set('stepConfigs', action.stepConfigs);
        case SET_PREFERRED_CURRENCY:
            return state.set('preferredCurrencyCode', action.currencyCode);
        case SET_PREFERRED_PROGRAM:
            return state.set('preferredProgramCode', action.programCode);
        default:
            return state;
    }
}




export function setFlowConfig(flowConfig) {
    return {
        type: SET_FLOW_CONFIG,
        flowConfig
    };
}


export function setStepConfigs(configs) {
    return {
        type: SET_STEP_CONFIGS,
        configs
    };
}


export function setPreferredCurrency(currencyCode) {
    return {
        type: SET_PREFERRED_CURRENCY,
        currencyCode
    };
}


export function removePreferredCurrency() {
    return setPreferredCurrency(null);
}


export function setPreferredProgram(programCode) {
    return {
        type: SET_PREFERRED_PROGRAM,
        programCode
    };
}


export function removePreferredProgram() {
    return setPreferredProgram(null);
}


export function flowParamsUpdated() {
    return { type: FLOW_PARAMS_UPDATED };
}


export function restartBuyFlow() {
    return { type: RESTART_BUY_FLOW };
}


export function orderComplete(orderDetails, segmentData) {
    return {
        type: ORDER_COMPLETE,
        orderDetails,
        meta: {
            segment: {
                event: 'track',
                eventAction: 'Order Completed',
                eventData: segmentData
            }
        }
    };
}


export function showAppError(errorType) {
    return {
        type: SHOW_APP_ERROR,
        errorType
    };
}


export function changeStep(path, sessionID = null) {
    return {
        type: STEP_CHANGE,
        path,
        sessionID
    };
}
